import React from 'react';
 
const OfferLetterForm = ({ data, setData, positionType }) => {
  const handleChange = (field, value) => {
    setData(prev => ({ ...prev, [field]: value }));
  };
 
  return (
    <div className="offer-form-section">
      <h3>Offer Letter Details - {positionType}</h3>
     
      <div className="offer-form-group">
        <label>Date</label>
        <input
          type="date"
          value={data.date || ''}
          onChange={(e) => handleChange('date', e.target.value)}
        />
      </div>
 
      <div className="offer-form-group">
        <label>Reference Number</label>
        <input
          type="text"
          value={data.refNo || ''}
          onChange={(e) => handleChange('refNo', e.target.value)}
          placeholder="e.g., BG/DC/-09-230925-307"
        />
      </div>
 
      <div className="offer-form-group">
        <label>Name</label>
        <input
          type="text"
          value={data.name || ''}
          onChange={(e) => handleChange('name', e.target.value)}
          placeholder="Enter full name"
        />
      </div>
 
      <div className="offer-form-group">
        <label>Address</label>
        <textarea
          value={data.address || ''}
          onChange={(e) => handleChange('address', e.target.value)}
          placeholder="Enter complete address"
          rows="3"
        />
      </div>
 
      <div className="offer-form-group">
        <label>Phone Number</label>
        <input
          type="text"
          value={data.phone || ''}
          onChange={(e) => handleChange('phone', e.target.value)}
          placeholder="Enter phone number"
        />
      </div>
 
      <div className="offer-form-group">
        <label>Email</label>
        <input
          type="email"
          value={data.email || ''}
          onChange={(e) => handleChange('email', e.target.value)}
          placeholder="Enter email address"
        />
      </div>
 
      <div className="offer-form-group">
        <label>Website Email</label>
        <input
          type="email"
          value={data.websiteEmail || 'info@bandhanguru.com'}
          onChange={(e) => handleChange('websiteEmail', e.target.value)}
          placeholder="info@bandhanguru.com"
        />
      </div>

      {positionType === 'State Head' && (
        <>
          <div className="offer-form-group">
            <label>Father's Name</label>
            <input
              type="text"
              value={data.fatherName || ''}
              onChange={(e) => handleChange('fatherName', e.target.value)}
              placeholder="Enter father's name"
            />
          </div>

          <div className="offer-form-group">
            <label>Alternate Mobile Number</label>
            <input
              type="text"
              value={data.alternatePhone || ''}
              onChange={(e) => handleChange('alternatePhone', e.target.value)}
              placeholder="Enter alternate mobile number"
            />
          </div>
        </>
      )}

      {positionType !== 'State Head' && positionType !=='Commissioner Manager' && (
        <div className="offer-form-group">
          <label>District</label>
          <input
            type="text"
            value={data.district || ''}
            onChange={(e) => handleChange('district', e.target.value)}
            placeholder="Enter district"
          />
        </div>
      )}

      {positionType === 'Commissioner Manager' && (
        <div className="offer-form-group">
          <label>Districts List (one per line)</label>
          <textarea
            value={data.districtsList || ''}
            onChange={(e) => handleChange('districtsList', e.target.value)}
            placeholder="Enter districts, one per line"
            rows="5"
          />
        </div>
      )}

      <div className="offer-form-group">
        <label>State</label>
        <input
          type="text"
          value={data.state || ''}
          onChange={(e) => handleChange('state', e.target.value)}
          placeholder="Enter state"
        />
      </div>
 
      <div className="offer-form-group">
        <label>Salary Description</label>
        <textarea
          value={data.salaryDescription || ''}
          onChange={(e) => handleChange('salaryDescription', e.target.value)}
          placeholder="Enter salary details"
          rows="3"
        />
      </div>
 
      <div className="offer-form-group">
        <label>Date of Joining</label>
        <input
          type="date"
          value={data.joiningDate || ''}
          onChange={(e) => handleChange('joiningDate', e.target.value)}
        />
      </div>
 
      <div className="offer-form-group">
        <label>Website URL</label>
        <input
          type="url"
          value={data.website || 'www.bandhanguru.com'}
          onChange={(e) => handleChange('website', e.target.value)}
          placeholder="www.bandhanguru.com"
        />
      </div>
    </div>
  );
};
 
export default OfferLetterForm;